export default {
  apiBase: 'https://stats.defisaver.com/api/',
};